import { germanMessages, deFootnotesNedc } from './common';

export default {
  ...germanMessages,
  'footnotes.nedc': deFootnotesNedc,
};
